/*
  Collection of useful methods for vanilla JS Date instances.
  Useful when installing moment is not really worth it.
*/

const padWithZero = number => (
  number < 10 ? `0${number}` : String(number)
);

class DateHelper {
  static isToday(date) {
    const currentDate = new Date();
    return (
      currentDate.getFullYear() === date.getFullYear() &&
      currentDate.getMonth() === date.getMonth() &&
      currentDate.getDate() === date.getDate()
    );
  }

  static toTimeLocalizedString(date) {
    let dayString = `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    if (DateHelper.isToday(date)) {
      dayString = 'hoy';
    }
    return `${dayString} a las ${padWithZero(date.getHours())}:${padWithZero(date.getMinutes())}`;
  }

  static militaryHourToString(time) {
    const hours = Math.floor(time / 100);
    const minutes = time % 100;
    return `${hours}:${minutes < 10 ? 0 : ''}${minutes}`;
  }
}

DateHelper.MONTHS = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Setiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

DateHelper.WEEKDAYS_LONG = [
  'Domingo',
  'Lunes',
  'Martes',
  'Miércoles',
  'Jueves',
  'Viernes',
  'Sábado',
];

DateHelper.WEEKDAYS_SHORT = [
  'Do',
  'Lu',
  'Ma',
  'Mie',
  'Ju',
  'Vie',
  'Sa',
];

export { DateHelper };



// WEBPACK FOOTER //
// ./src/helpers/DateHelper.js